import { useState } from 'react';

/**
 * Represents a sales file model.
 * @returns {Object} An object containing the sales file state and setter function.
 */
const salesFileModel = () => {
  const initialState = {
    isDaily: true,
    fileDate: '',
    fileMonth: [],
    fileYear: '',
  };

  const [salesFile, setSalesFile] = useState(initialState);

  return { salesFile, setSalesFile, initialState };
};

export default salesFileModel;
